import { HalResource } from '../hal/models/HalResource';
/**
 * Class representing the no results rate for searches in an Algolia Search Index
 */
export class SearchIndexNoResultsRate extends HalResource {
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoSW5kZXhOb1Jlc3VsdHNSYXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbC9TZWFyY2hJbmRleE5vUmVzdWx0c1JhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBU3hEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHdCQUF5QixTQUFRLFdBQVc7Q0FrQnhEIn0=